var map = {
	"./BadgeCard": 62150,
	"./BadgeCard.tsx": 62150,
	"./BasicCard": 6349,
	"./BasicCard.tsx": 6349,
	"./BasicTestimonialCard": 45824,
	"./BasicTestimonialCard.tsx": 45824,
	"./BioCard": 78206,
	"./BioCard.tsx": 78206,
	"./DynamicCard": 36432,
	"./DynamicCard.tsx": 36432,
	"./EntryCard": 47779,
	"./EntryCard.tsx": 47779,
	"./FeaturedCard": 1141,
	"./FeaturedCard.tsx": 1141,
	"./ImageCard": 90568,
	"./ImageCard.tsx": 90568,
	"./InformationCard": 70729,
	"./InformationCard.tsx": 70729,
	"./MiniCard": 22778,
	"./MiniCard.tsx": 22778,
	"./PricingCard": 7193,
	"./PricingCard.tsx": 7193,
	"./PricingCardCTA": 78863,
	"./PricingCardCTA.tsx": 78863,
	"./ProductCard": 9438,
	"./ProductCard.tsx": 9438,
	"./RestaurantCard": 74438,
	"./RestaurantCard.tsx": 74438,
	"./SearchCard": 707,
	"./SearchCard.tsx": 707,
	"./TestimonialCard": 23966,
	"./TestimonialCard.tsx": 23966,
	"./__tests__/BadgeCard.test": 52652,
	"./__tests__/BadgeCard.test.tsx": 52652,
	"./__tests__/BasicCard.test": 76649,
	"./__tests__/BasicCard.test.tsx": 76649,
	"./__tests__/BasicTestimonialCard.test": 22758,
	"./__tests__/BasicTestimonialCard.test.tsx": 22758,
	"./__tests__/DynamicCard.test": 5266,
	"./__tests__/DynamicCard.test.tsx": 5266,
	"./__tests__/EntryCard.test": 41727,
	"./__tests__/EntryCard.test.tsx": 41727,
	"./__tests__/FeaturedCard.test": 34761,
	"./__tests__/FeaturedCard.test.tsx": 34761,
	"./__tests__/ImageCard.test": 40694,
	"./__tests__/ImageCard.test.tsx": 40694,
	"./__tests__/InformationCard.test": 40297,
	"./__tests__/InformationCard.test.tsx": 40297,
	"./__tests__/MiniCard.test": 61576,
	"./__tests__/MiniCard.test.tsx": 61576,
	"./__tests__/PricingCard.test": 42841,
	"./__tests__/PricingCard.test.tsx": 42841,
	"./__tests__/ProductCard.test": 10928,
	"./__tests__/ProductCard.test.tsx": 10928,
	"./__tests__/RestaurantCard.test": 77912,
	"./__tests__/RestaurantCard.test.tsx": 77912,
	"./__tests__/TestimonialCard.test": 72640,
	"./__tests__/TestimonialCard.test.tsx": 72640,
	"./__tests__/__snapshots__/ProductCard.test.tsx.snap": 17092,
	"./types.d": 35416,
	"./types.d.ts": 35416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83709;